var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.6842H13.875C14.7038 11.6842 15.4987 12.0169 16.0847 12.6091C16.6708 13.2014 17 14.0046 17 14.8421C17 15.6796 16.6708 16.4829 16.0847 17.0751C15.4987 17.6673 14.7038 18 13.875 18H7V6H12.9375C13.6834 6 14.3988 6.29944 14.9262 6.83243C15.4537 7.36543 15.75 8.08833 15.75 8.84211C15.75 9.59588 15.4537 10.3188 14.9262 10.8518C14.3988 11.3848 13.6834 11.6842 12.9375 11.6842",
    stroke: "#808080",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldText);
export default __webpack_public_path__ + "static/media/bold-text.f1fb4fa3c1322da5b98e482bbece052c.svg";
export { ForwardRef as ReactComponent };